import MixingFunctions from '../components/MixingFunctions';
import PartinerList from '../components/PartinerList';

new Vue({
    el: '#main-content',
    mixins: [
        MixingFunctions
    ],
    components: {
        'stretch': VueLoadingSpinner.Stretch,
        PartinerList
    },
    data: {
        baseLink: window.vueData.baseLink,
        filters: window.vueData.filters,
        corLoading: window.vueData.corLoading,
        bannersMeio: window.vueData.bannersMeio,
        bannersDestaque: window.vueData.bannersDestaque,
        bannersParceiros: window.vueData.bannersParceiros,
        loading: true,
        categoriasList: window.vueData.categoriasList,
        lojas: window.vueData.lojas,
        storage: window.vueData.storage,
        filterMarcas: true
    },
    methods: {
    }
});
